import React, { forwardRef } from 'react';
import { Box, IconTile, Text } from './Callout.styles';

const ICONS = {
    tip: 'ri-lightbulb-flash-fill',
    info: 'ri-information-fill',
    warning: 'ri-error-warning-fill',
    error: 'ri-error-warning-fill',
};

/** Tip / info / warning / error box. Error callouts are `role="alert"` and focusable. */
const Callout = forwardRef(({ variant = 'tip', title, children, ...rest }, ref) => (
    <Box
        ref={ref}
        variant={variant}
        role={variant === 'error' ? 'alert' : undefined}
        tabIndex={variant === 'error' ? -1 : undefined}
        {...rest}
    >
        <IconTile variant={variant} aria-hidden="true">
            <i className={ICONS[variant]} />
        </IconTile>
        <Text variant={variant}>
            {title && <strong>{title}</strong>}
            {children}
        </Text>
    </Box>
));

export default Callout;
